<template>
  <div class="question-result">
    <div class="result-con">
      <div class="title">
        {{ detail && detail.className }}
        <div class="tag">LV{{ detail && detail.difficultyLevel }}</div>
      </div>
      <div class="result-flex">
        <div class="flex-con">
          <div class="flex-txt">正确率</div>
          <div class="flex-txt2">{{ detail && detail.accuracy }}</div>
        </div>
        <div class="flex-con">
          <div class="flex-txt">总题数</div>
          <div class="flex-txt2">{{ detail && detail.questionNum }}</div>
        </div>
        <div class="flex-con">
          <div class="flex-txt">答对</div>
          <div class="flex-txt2">{{ detail && detail.correctNum }}</div>
        </div>
      </div>
    </div>
    <div class="con-list">
      <div class="title">
        选择题
      </div>
      <div class="flex-list">
        <div class="items-btn" v-for="(item, index) in topicList"
          :class="item.answerStatus + '' === '1' ? 'cur1' : item.answerStatus + '' === '2' ? 'cur2' : item.answerStatus + '' === '3' ? 'cur3' : ''"
          :key="index">{{ index + 1 }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getClassStat, getTopicNumber } from '../../api/questionBank'
import { getShareInfo } from '@/utils/wxShare'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      detail: {},
      className: '',
      topicList: []
    }
  },
  mounted () {
    getShareInfo({
      title: 'iEP-心电图分类题库',
      titleTimeLine: 'iEP-海量心电图分类题库，进阶心电王者',
      desc: '解锁更多题目，进阶心电王者',
      link: window.location.href + `${window.location.href.indexOf('?') > -1 ? '&' : '?'}shareColl=true`,
      linkTimeLine: window.location.href + `${window.location.href.indexOf('?') > -1 ? '&' : '?'}shareColl=true`,
      images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
    })
    let params = {
      classCode: this.$route.query.classCode,
      difficultyLevel: this.$route.query.difficultyLevel
    }
    getClassStat(params).then(res => {
      this.detail = res.data
    })
    this.handleUpdateTopicNum()
  },
  methods: {
    handleUpdateTopicNum () {
      getTopicNumber({
        classCode: this.$route.query.classCode,
        difficultyLevel: this.$route.query.difficultyLevel
      }).then(res => {
        console.log(res)
        this.topicList = res.data
      })
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.question-result {
  padding-top: 16px;
  box-sizing: border-box;
  background: #F9F8F7;

  .title {
    display: flex;
    padding-left: 30px;
    align-items: center;
    position: relative;
    font-size: 14px;
    color: #333333;
    font-weight: 500;
    line-height: 24px;

    .tag {
      margin-left: 8px;
      width: 30px;
      height: 14px;
      font-size: 12px;
      border-radius: 2px;
      background-color: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.6);
      line-height: 14px;
      text-align: center;
    }

    &::before {
      position: absolute;
      width: 4px;
      height: 12px;
      left: 22px;
      top: 5.5px;
      background-color: #EB1700;
      border-radius: 100px;
      content: '';
    }
  }

  .result-con {
    background-color: #fff;
    margin: 0 16px 16px;
    border-radius: 8px;
    padding: 14px 0;
    box-sizing: border-box;

    .result-flex {
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 13px;

      .flex-con {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .flex-txt {
          font-size: 12px;
          color: #6A7481;
          line-height: 20px;
          margin-bottom: 6px;
        }

        .flex-txt2 {
          font-size: 20px;
          color: #000000;
          font-weight: bold;
        }
      }
    }
  }

  .con-list {
    width: 100%;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    padding: 14px 14px 0;
    box-sizing: border-box;

    .flex-list {
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      padding: 0 11px;
      box-sizing: border-box;
      margin-top: 20px;

      .items-btn {
        width: 40px;
        height: 40px;
        margin-right: 17px;
        margin-bottom: 16px;
        background-color: rgba(24, 24, 24, 0.08);
        font-size: 16px;
        color: rgba(0, 0, 0, 0.3);
        font-weight: bold;
        text-align: center;
        line-height: 40px;
        border-radius: 50%;
        &.cur3 {
          background-color: #328714;
          color: #fff;
        }
        &.cur1 {
          background-color: #EB1700;
          color: #fff;
        }

        &:nth-child(6n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/questionBank/questionResult.vue